type iCart = {
    orders : number
}
const CartIcon:React.FC<iCart> = ({orders}) => {

    return (
        <>
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 799.2 799.2" width={'50'}>
  <path d="M569.7,217.9c-20-2.8-40.1-5.1-60.1-6.9v-11.1c0-36.3-29.5-65.8-65.8-65.8h-87.5c-36.3,0-65.8,29.5-65.8,65.8v10.8c-20.5,1.8-41.1,4.2-61.6,7.1-15.1,2.8-25.1,15.3-28.2,38.5-11.6,104.4-11.7,208.2,0,311.5,3.5,22.6,10.2,32.8,28.2,38.5,113.1,19.4,226.7,19.2,340.8,0,16.6-3.4,25.3-14.7,28.2-38.5,12.5-103.3,12.4-207.1,0-311.4-3.7-24.9-11.6-35.1-28.2-38.5ZM483.6,208.8c-55.8-3.9-111.5-4-167.1-.2v-8.8c0-21.9,17.8-39.8,39.8-39.8h87.5c22,0,39.8,17.9,39.8,39.8v9Z" fill={orders > 0 ? "#2b2b2b" : "#64646489"}/>
  <path className="st0" d="M443.8,160h-87.5c-22,0-39.8,17.9-39.8,39.8v8.8c55.6-3.8,111.3-3.7,167.1.2v-9c0-21.9-17.8-39.8-39.8-39.8Z" fill="none"/>
  <text fill="#ffa409" x={'50%'} y={'55%'} fontSize={'320'} textAnchor="middle" dominantBaseline="middle">{orders > 0 && orders}</text>
</svg>
        </>
    )
}
export default CartIcon